import SearchPageFiltersDropdown from "./SearchPageFiltersDropdown";
import { useTheme } from "../Theme";


export default function SearchPageFilters() {
    const { darkMode, toggleModes } = useTheme();

    const ThemeClasses = darkMode
      ? "bg-slate-800 text-white "
      : "bg-white-800 text-black ";

    return (
        <>
            <div className="content sm:w-[200px]">

                <h1 className={`text-3xl font-semibold text-qblack mb-2.5 ${ThemeClasses}`}>Filters</h1>

                <SearchPageFiltersDropdown
                    labelText={"Filter 1"}
                    subItems={[
                        {labelText: "Sub-Filter 1"},
                        {labelText: "Sub-Filter 2"},
                        {labelText: "Sub-Filter 3"},
                    ]}>

                </SearchPageFiltersDropdown>

                {/* <ul>
                    

                    <li><input type="checkbox" name="" id="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/><span className="text-lg"> Filter 2</span></li>

                    <li><input type="checkbox" name="" id="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/><span className="text-lg"> Filter 3</span></li>

                </ul> */}

            </div>
        </>
    )
}